/********************************************************************
 * jquery.js
 * Accessing jQuery from outside of Webpack JavaScript Files.
 */

// create global $ and jQuery variables
global.$ = global.jQuery = $;